
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Statistics from './components/Statistics';
import About from './components/About';
import Methodology from './components/Methodology';
import Offers from './components/Offers';
import FreeAdvice from './components/FreeAdvice';
import Questions from './components/Questions';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Statistics />
      <About />
      <Methodology />
      <Offers />
      <FreeAdvice />
      <Questions />
      <Contact />
      <Footer />
    </div>
  );
}
